import React from 'react';

import styled from 'styled-components';

import {
  ILocaleStringFragment,
  ILocaleVideoFileFragment,
  IVideoWidget,
} from 'generated/sanity-graphql';

const Container = styled.div`
  display: block;
  width: 90%;
  max-width: 920px;
  overflow: hidden;
  margin: 2.5rem auto;
  ${Styles.mobile} {
    margin: 1.5rem auto;
  }
`;
const Video = styled.video`
  width: 100%;
  display: block;
  border-radius: 4px;
`;

const VideoCaption = styled.figcaption`
  padding-block-start: 1rem;
  font-size: 0.875rem;
  & > a {
    color: ${Styles.color.primary};
    margin-inline-end: 0.33rem;
  }
`;

export type IVideoWidgetProps = Pick<IVideoWidget, 'attributionLink'> & {
  caption?: ILocaleStringFragment;
  video: ILocaleVideoFileFragment;
};

export const VideoWidget: React.FC<IVideoWidgetProps> = ({ attributionLink, caption, video }) => (
  <Container role="figure" aria-labelledby={video.locale?.asset?.assetId ?? 'video-caption'}>
    <Video controls>
      <source src={video.locale?.asset?.url ?? undefined} type="video/mp4" />
    </Video>
    <VideoCaption id={video.locale?.asset?.assetId ?? 'video-caption'}>
      {attributionLink && <a href={attributionLink}>Video Source</a>}
      {caption?.locale}
    </VideoCaption>
  </Container>
);
